import { api } from './axios.js';

/**
 * Эндпоинттер — ар домен үчүн бир объект, `.data.data` дароо чечилет.
 * Компоненттер axios'ту эч качан түз чакырбайт (SERVER_WEB_STACK §8.1).
 */
const unwrap = (r) => r.data.data;

export const authApi = {
  login: (login, password) => api.post('/auth/login', { login, password }).then(unwrap),
  me: () => api.get('/auth/me').then(unwrap),
  logout: (refreshToken) => api.post('/auth/logout', { refreshToken }),
  updatePrefs: (patch) => api.patch('/auth/me/prefs', patch).then(unwrap),
  changePassword: (currentPassword, newPassword) =>
    api.post('/auth/change-password', { currentPassword, newPassword }),
};

export const languagesApi = {
  list: (params) => api.get('/languages', { params }).then(unwrap),
};

export const projectsApi = {
  list: (params) => api.get('/projects', { params }).then(unwrap),
  getOne: (id) => api.get(`/projects/${id}`).then(unwrap),
  chapters: (id) => api.get(`/projects/${id}/chapters`).then(unwrap),
  update: (id, body) => api.patch(`/projects/${id}`, body).then(unwrap),
  remove: (id) => api.delete(`/projects/${id}`),

  /**
   * ТЗ 11.1 — долбоор файл жүктөө аркылуу түзүлөт.
   * `onProgress(0..100)` — 300 МБ файлда колдонуучу жүктөлүп жатканын көрүшү керек.
   */
  create: (formData, { onProgress } = {}) => api.post('/projects', formData, {
    // Таймаут жок: чоң файл жай интернетте мүнөттөп жүктөлөт
    timeout: 0,
    onUploadProgress: (e) => {
      if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
    },
  }).then(unwrap),
};

export const chaptersApi = {
  getOne: (id) => api.get(`/chapters/${id}`).then(unwrap),
  segments: (id, params) => api.get(`/chapters/${id}/segments`, { params }).then(unwrap),
  toggleBookmark: (id) => api.post(`/chapters/${id}/bookmark`).then(unwrap),
  updateStage: (id, stage, status) => api.patch(`/chapters/${id}/stages/${stage}`, { status }).then(unwrap),
  remove: (id) => api.delete(`/chapters/${id}`),
};

/** ТЗ 11.7, 11.12, 4.2 — сегментти оңдоо, тарых, откат, кулпу */
export const segmentsApi = {
  save: (id, stage, text) => api.put(`/segments/${id}/stages/${stage}`, { text }).then(unwrap),
  versions: (id, stage) => api.get(`/segments/${id}/versions`, { params: { stage } }).then(unwrap),
  restore: (id, versionId) => api.post(`/segments/${id}/versions/${versionId}/restore`).then(unwrap),
  lock: (id) => api.post(`/segments/${id}/lock`).then(unwrap),
  unlock: (id) => api.delete(`/segments/${id}/lock`),
};

/** ТЗ 11.8 — глоссарий */
export const glossaryApi = {
  list: (projectId, params) => api.get(`/projects/${projectId}/glossary`, { params }).then(unwrap),
  create: (projectId, body) => api.post(`/projects/${projectId}/glossary`, body).then(unwrap),
  update: (termId, body) => api.patch(`/glossary/${termId}`, body).then(unwrap),
  remove: (termId) => api.delete(`/glossary/${termId}`),
  bulk: (projectId, ids, status) => api.post(`/projects/${projectId}/glossary/bulk`, { ids, status }).then(unwrap),
  extract: (projectId) => api.post(`/projects/${projectId}/glossary/extract`).then(unwrap),
};

/** ТЗ 11.13 — экспорт */
export const exportApi = {
  create: (projectId, body) => api.post(`/projects/${projectId}/export`, body).then(unwrap),
  list: (projectId) => api.get(`/projects/${projectId}/exports`).then(unwrap),
};

/** ТЗ 11.10 — китеп боюнча издөө */
export const searchApi = {
  search: (projectId, params) => api.get(`/projects/${projectId}/search`, { params }).then(unwrap),
};

/** ТЗ 11.11 — «Здоровье книги» */
export const qualityApi = {
  health: (projectId) => api.get(`/projects/${projectId}/health`).then(unwrap),
  check: (projectId) => api.post(`/projects/${projectId}/health/check`).then(unwrap),
  issues: (projectId, params) => api.get(`/projects/${projectId}/issues`, { params }).then(unwrap),
  setStatus: (issueId, status) => api.patch(`/issues/${issueId}`, { status }).then(unwrap),
};

/** ТЗ 11.15 — резервдик көчүрмө → Telegram */
export const backupApi = {
  overview: () => api.get('/backups').then(unwrap),
  alert: () => api.get('/backups/alert').then(unwrap),
  saveSettings: (body) => api.put('/backups/settings', body).then(unwrap),
  test: () => api.post('/backups/test').then(unwrap),
  create: () => api.post('/backups').then(unwrap),
};

/** ТЗ 11.3–11.6 — AI конвейери; ТЗ 13 — болжолдуу наркы */
export const pipelineApi = {
  runProject: (projectId, stage, body) => api.post(`/projects/${projectId}/stages/${stage}/run`, body).then(unwrap),
  runChapter: (chapterId, stage, body) => api.post(`/chapters/${chapterId}/stages/${stage}/run`, body).then(unwrap),
  estimate: (projectId, stage, params) => api.get(`/projects/${projectId}/stages/${stage}/estimate`, { params }).then(unwrap),
  // ТЗ 11.7 — «Уверенность AI»: баскыч менен гана
  estimateConfidence: (chapterId, stage, params) => api.get(`/chapters/${chapterId}/stages/${stage}/confidence/estimate`, { params }).then(unwrap),
  rateConfidence: (chapterId, stage, modelId) => api.post(`/chapters/${chapterId}/stages/${stage}/confidence`, { modelId }).then(unwrap),
};

/** ТЗ 11.14 — учётные записи (все — «Администратор») */
export const usersApi = {
  list: () => api.get('/users', { params: { limit: 100 } }).then(unwrap),
  create: (body) => api.post('/users', body).then(unwrap),
  update: (id, body) => api.patch(`/users/${id}`, body).then(unwrap),
  remove: (id) => api.delete(`/users/${id}`),
};

/** ТЗ 10.2 — шаблоны промптов */
export const promptTemplatesApi = {
  list: () => api.get('/prompt-templates').then(unwrap),
  update: (id, body) => api.put(`/prompt-templates/${id}`, { body }).then(unwrap),
  reset: (id) => api.post(`/prompt-templates/${id}/reset`).then(unwrap),
};

/** ТЗ 10.1 — AI моделдеринин справочниги */
export const aiModelsApi = {
  list: () => api.get('/ai-models').then(unwrap),
  providerModels: (provider) => api.get(`/ai-models/providers/${provider}`).then(unwrap),
  create: (body) => api.post('/ai-models', body).then(unwrap),
  update: (id, body) => api.patch(`/ai-models/${id}`, body).then(unwrap),
  setOcrModel: (modelId) => api.put('/ai-models/ocr-model', { modelId }).then(unwrap),
  setGlossaryModel: (modelId) => api.put('/ai-models/glossary-model', { modelId }).then(unwrap),
};

export const jobsApi = {
  getOne: (id) => api.get(`/jobs/${id}`).then(unwrap),
  list: (params) => api.get('/jobs', { params }).then(unwrap),
  cancel: (id) => api.post(`/jobs/${id}/cancel`).then(unwrap),
};

export const importReviewApi = {
  pages: (projectId) => api.get(`/projects/${projectId}/import-pages`).then(unwrap),
  updatePage: (pageId, body) => api.patch(`/import-pages/${pageId}`, body).then(unwrap),
  confirm: (projectId) => api.post(`/projects/${projectId}/confirm-import`).then(unwrap),
  retryOcr: (projectId) => api.post(`/projects/${projectId}/retry-ocr`).then(unwrap),
};
